<template>
  <div>
    <Content></Content>
  </div>
</template>

<script>
import Content from "./content"
import { post } from "../../../static/js/common"

export default {
  name: "App",
  components: {
    Content,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/index/index.vue